import React from 'react'
import file from '../../../../Global/assets/Dispersion.mp4'

const Dispersion = () => {
    return (
        <>
            <div id="ExperimentsB" style={{ height: '110vh' }}>
                <div style={{ width: '80%', height: '50%' }}>
                    <video src={file} width='100%' height='100%' controls></video>
                </div>
                <div style={{ width: '80%', height: '30vh', color: '#fff' }}>
                    <h1>Dispersion - Splitting of Sunlight into 7 Colours</h1><br />
                    <h6>Observations : </h6><br />
                    <h6>1. The object used here is a Crystal-Ball like object with multiple prisms in it.</h6>
                    <h6>2. The Sunlight is entering into the object.</h6>
                    <h6>3. The sunlight then Splits into its 7 Component Colours also known as VIBGYOR.</h6>
                    <h6>4. VIBGYOR - Red, Orange, Yellow, Green, Blue, Indigo, Violet</h6>
                    <h6>5. The ray of the sunlight gets reflected and refracted</h6>
                </div>
            </div>
        </>
    )
}

export { Dispersion }